import * as $ from 'jquery';
import { recaptchaObject } from "./recaptcha";

export class externalProductForm {
	private $scope:any = $('#container-message_board');

	submitForm():void {
        let _self:this;
        let submitBtn:any = $("#message-form--submit");
        function validateEmail(email:any) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
          }

   submitBtn.click((evt: any) => {
        $(window).unbind('scroll');
        evt.preventDefault();
        evt.stopPropagation();
        $('.login-validator-success').addClass('hide');
        $('.login-validator-failure').addClass('hide');
        var form_name=$('#message-form--name').val();
        var form_message=$('#message-form-message').val();
        var form_email=$('#message-form--email').val();
        var hidden_identifier=$('input[name="Campagn"]').val();
        $('.login-validator .error_message').addClass('hide');
        $('.login-validator .validmail').remove();
        $('#message-form--submit').css({ 'opacity': '0.5','pointer-events': 'none' });

        let valid:any=true;
        $('.login-validator-success').addClass('hide');
        if (validateEmail(form_email) || form_email =="") 
        {
            $('.login-validator .validmail').remove();
        } 
        else 
        {
            $('.login-validator').append('<div class="validmail">Please enter a vaild Email Address.</div>')   ;
            valid=false;     
            $('#message-form--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });

        }
        if(form_name=="" || form_message=="" || form_email=="" )
        {
            $('.login-validator .error_message').removeClass('hide');
            valid=false;
            $('#message-form--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });
        }
        if(valid)
        {
            $('.login-validator .error_message').addClass('hide')
        let data:any = {
            'name' : form_name,
            'message' : form_message,
            'messageID':hidden_identifier,
            'email':form_email,
            }
        $.ajax({
                type: 'POST',
                data:data,
                url: '/bin/services/new/submitMessage',
                success: function(msg:any) {
                if(typeof msg==='string'){
                msg = JSON.parse(msg);
                }else{
                    msg=msg;
                }
                if(msg.status=='true')
                {
                    $('.login-validator-success').removeClass('hide');
                    $('#message-form--name').val('');
                    $('#message-form-message').val('');
                    $('#message-form--email').val('');
                    $('#message-form--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });
                }
                else
                {
                    $('.login-validator-success').addClass('hide');
                    $('.login-validator-failure').removeClass('hide');
                    $('#message-form--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });

                }
                },
                error: function(error:any) {
                /// just for testing
                $('.login-validator-success').addClass('hide');
                $('.login-validator-failure').removeClass('hide');
                $('#message-form--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });
                }
            });
        }
 });
}
initloadmessages():any
{

    let messageboardurl;
    $(".login-validator-msgfailure").addClass('hide')

    if (window.location.hostname === 'localhost' && window.location.port == '5000') {
		messageboardurl = '/dummy-data/camp_message.json';
	}
	else {
		messageboardurl = '/bin/services/new/displayMessage';
    }
    var hidden_identifier=$('input[name="Campagn"]').val();
    let data:any = {
        'messageID':hidden_identifier
        }
    $.ajax({
        type: 'GET',
        data:data,
        url: messageboardurl,
        success: function(msg:any) {
        if(typeof msg==='string'){
        msg = JSON.parse(msg);
        }else{
            msg=msg;
        }
        if(msg.status=="success")
        {
            $(".message-board--content").show();
            var i, j, resArray=[], chunk = 20;
            for (i = 0, j = msg.messages.length; i < j; i += chunk) {
            resArray.push(msg.messages.slice(i, i + chunk));
            }
            localStorage.setItem("message-board", JSON.stringify(resArray));
            var trHTML = '';
            for(let i=0;i<resArray[0].length;i++)
            {
                trHTML += '<div class="col-lg-12 col-md-12 col-sm-12 camp-messages"><b>'+resArray[0][i].name+'</b><div>'+resArray[0][i].commentDate+'- '+'<span>'+resArray[0][i].comment+'</span></div></div>';       
            }
            $('#message-board--messages').append(trHTML);
        }
        else if(msg.status=="nodata") 
        {
            $(".message-board--content").hide();
        }
        else if(msg.status=="error")
        {
            $(".message-board--content").hide();
        }
    
    }
        ,
        error: function(error:any) {
            $(".login-validator-msgfailure").removeClass('hide')
        }
    });
}
viewMessges():any{
    let submitBtn:any = $("#view_messages");
    var count=1;
    $('#message-board--messages').on('scroll', function(evt:any) {
        let isvalid:any=false;

        if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) 
        {
            var dataList = JSON.parse(localStorage['message-board']);
            var trHTML = '';   
            for(let i=0;i<dataList[count].length;i++)
            {
                trHTML += '<div class="col-lg-12 col-md-12 col-sm-12 camp-messages"><b>'+dataList[count][i].name+'</b><div>'+dataList[count][i].commentDate+'- '+'<span>'+dataList[count][i].comment+'</span></div></div>';
            }
            $('#message-board--messages').append(trHTML);
            count++
            $(window).unbind('scroll');
            evt.preventDefault();
            evt.stopPropagation();
        }

    })
}
}

let scope:Element = document.querySelector('#container-message_board')
if (scope) { 
try {
    let extprodform = new externalProductForm();
        extprodform.initloadmessages()
        extprodform.submitForm();
        extprodform.viewMessges();
    }
  catch(e) {console.error(e);}
}

